module.exports = __webpack_public_path__ + "static/media/family.9fbab0d0.jpg";